import { UiLayoutConstant } from '@/globals/uiLayoutConstant'
import { ContentPath } from 'common/src/ContentPath'

export const getOutlinePagePathnameForContentPath = (
    contentPath: ContentPath | null
): string => {
    return UiLayoutConstant.OUTLINE_PAGE + contentPath?.join('/')
}
